import { singleton } from '@front-app/util/interface';
import { getBootstrapStore } from '../modules/bootstrap';
import { CurrentUserStore } from './User';

export const BootstrapStore = singleton(() => getBootstrapStore(CurrentUserStore));
